module.exports = __webpack_public_path__ + "media/images/convenios/aso_odontologica-ad48a85aeca800b4e417e665a2b42d12.jpg";